type FullStoryModule = typeof import('@fullstory/browser');

type RuntimeEnvironment = {
  ENABLE_FULLSTORY?: boolean | string | number;
  REACT_APP_FULLSTORY_ORG_ID?: string;
};

const { __environment__ } = window as Window & {
  __environment__: RuntimeEnvironment;
};

let initializationPromise: Promise<FullStoryModule | null> | null = null;

function isTruthyRuntimeFlag(value: RuntimeEnvironment['ENABLE_FULLSTORY']) {
  if (typeof value === 'boolean') {
    return value;
  }

  if (typeof value === 'number') {
    return value !== 0;
  }

  if (typeof value === 'string') {
    return ['1', 'on', 'true', 'yes'].includes(value.trim().toLowerCase());
  }

  return false;
}

export function isFullStoryEnabled() {
  return isTruthyRuntimeFlag(__environment__?.ENABLE_FULLSTORY);
}

export function initializeFullStory() {
  const fullStoryOrgId = __environment__?.REACT_APP_FULLSTORY_ORG_ID?.trim();

  if (!isFullStoryEnabled() || !fullStoryOrgId) {
    return Promise.resolve(null);
  }

  if (!initializationPromise) {
    initializationPromise = import('@fullstory/browser').then((fullStory) => {
      fullStory.init({ orgId: fullStoryOrgId });
      return fullStory;
    });
  }

  return initializationPromise;
}

export function setFullStoryUser(emailAddress?: string | null) {
  if (!emailAddress) {
    return;
  }

  void initializeFullStory().then((fullStory) => {
    if (!fullStory) {
      return;
    }

    fullStory.FullStory('setProperties', {
      type: 'user',
      properties: {
        email: emailAddress,
      },
    });
  });
}
